import { render, staticRenderFns } from "./BottomNav.vue?vue&type=template&id=485215c6&scoped=true&lang=html"
import script from "./BottomNav.vue?vue&type=script&lang=js"
export * from "./BottomNav.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "485215c6",
  null
  
)

export default component.exports